module.exports = __webpack_public_path__ + "static/media/logo-digit-h-blanc.7704c587.png";